import { render } from "./tasks.vue?vue&type=template&id=c79d3e64&scoped=true&ts=true"
import script from "./tasks.vue?vue&type=script&lang=ts"
export * from "./tasks.vue?vue&type=script&lang=ts"

import "./tasks.vue?vue&type=style&index=0&id=c79d3e64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79d3e64"]])

export default __exports__